import { ID } from '@rossum/api-client';

export const CREDENTIALS_QUERY_KEY = 'integration-credentials';

export const credentialKeys = {
  all: [CREDENTIALS_QUERY_KEY] as const,
  list: () => [CREDENTIALS_QUERY_KEY, 'list'] as const,
  detail: (credentialId: ID) =>
    [CREDENTIALS_QUERY_KEY, 'detail', credentialId] as const,
  hooks: (hookIds: ID[]) => [CREDENTIALS_QUERY_KEY, 'hooks', hookIds] as const,
};
